import React, { useState, useEffect } from 'react';

import { func_file, func_validation } from 'functions';
import moment from 'moment';



export function useBillingSetupExcelImport(props) {
    const { importMassBillingSetup_requesting } = props;

    // States
    const [billingSetupList, setBillingSetupList] = useState([]);
    const [uploadedFileName, setUploadedFileName] = useState("");
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [alertMsgType, setAlertMsgType] = useState("");
    const [inputUniqueId] = useState(func_validation.getStringUniqueId("billingSetupUpload"));

    function reformatBillingSetupListData(data) {
        // Group arrays to get the Billing Setup Details data
        // NOTE: Same 'CompanyId', 'AccountCode', and 'ProductCode' 
        //       indicates multiple billing setup detail.
        
        let companyId_current = "", 
        accountCode_current = "", 
        productCode_current = "",
        dealerCode_current = "",
        salesPersonCode_current = "",
        productName_current = "",
        isDefaultProduct_current = "",
        chargeMethod_current = "",
        posCountToCharge_current = "",
        systemChargeMethodComment_current = "",
        subscriptionMethod_current = "",
        billFrequence_current = "",
        unitPrice_current = "",
        quantity_current = "",
        advancePay_current = "",
        unitDiscountAmount_current = "",
        isBillInForeignCurrency_current = "",
        currencyCode_current = "",
        currencyRate_current = "",
        transactionCountToCharge_current = "",
        lastBilledDateTime_current = "",
        nextBilledDateTime_current = "",
        cutOffDate_current = "",
        lastBilledDateDay_current = "",
        isSuspense_current = "";

        let billingSetupList_new = [];
        let alertMsg_new = "", alertMsgType_new = "";

        data.map((billingSetupDetails, idx) => {
            let companyId = func_validation.getObjectPropertyValue(billingSetupDetails, "CompanyId", 0);

            let accountCode = func_validation.getObjectPropertyValue(billingSetupDetails, "AccountCode", "") + "";
            let accountCode_trimmed = func_validation.getTrimmedString(accountCode);

            let dealerCode = func_validation.getObjectPropertyValue(billingSetupDetails, "DealerCode", "") + "";
            let dealerCode_trimmed = func_validation.getTrimmedString(dealerCode);

            let salesPersonCode = func_validation.getObjectPropertyValue(billingSetupDetails, "SalesPersonCode", "") + "";
            let salesPersonCode_trimmed = func_validation.getTrimmedString(salesPersonCode);

            let productCode = func_validation.getObjectPropertyValue(billingSetupDetails, "ProductCode", "") + "";
            let productCode_trimmed = func_validation.getTrimmedString(productCode);

            let productName = func_validation.getObjectPropertyValue(billingSetupDetails, "ProductName", "") + "";
            let productName_trimmed = func_validation.getTrimmedString(productName);

            let isDefaultProduct = func_validation.getObjectPropertyValue(billingSetupDetails, "IsDefaultProduct");
            let chargeMethod = func_validation.getObjectPropertyValue(billingSetupDetails, "ChargeMethod", "OutletTransaction") + "";
            let chargeMethod_trimmed = func_validation.getTrimmedString(chargeMethod);

            let posCountToCharge = func_validation.getObjectPropertyValue(billingSetupDetails, "POSCountToCharge", 0);

            let systemChargeMethodComment = func_validation.getObjectPropertyValue(billingSetupDetails, "SystemChargeMethodComment", "") + "";
            let systemChargeMethodComment_trimmed = func_validation.getTrimmedString(systemChargeMethodComment);

            let subscriptionMethod = func_validation.getObjectPropertyValue(billingSetupDetails, "SubscriptionMethod", "Monthly") + "";
            let subscriptionMethod_trimmed = func_validation.getTrimmedString(subscriptionMethod);

            let billFrequence = func_validation.getObjectPropertyValue(billingSetupDetails, "BillFrequence", 1);
            let unitPrice = func_validation.getObjectPropertyValue(billingSetupDetails, "UnitPrice", 0);
            let quantity = func_validation.getObjectPropertyValue(billingSetupDetails, "Quantity", 0);
            let advancePay = func_validation.getObjectPropertyValue(billingSetupDetails, "AdvancePay", 0);
            let unitDiscountAmount = func_validation.getObjectPropertyValue(billingSetupDetails, "UnitDiscountAmount", 0);
            let isBillInForeignCurrency = func_validation.getObjectPropertyValue(billingSetupDetails, "IsBillInForeignCurrency");

            let currencyCode = func_validation.getObjectPropertyValue(billingSetupDetails, "CurrencyCode", "MYR") + "";
            let currencyCode_trimmed = func_validation.getTrimmedString(currencyCode);

            let currencyRate = func_validation.getObjectPropertyValue(billingSetupDetails, "CurrencyRate", 1);

            let transactionCountToCharge = func_validation.getObjectPropertyValue(billingSetupDetails, "TransactionCountToCharge");

            let currentDate_toString = moment().format("YYYY-MM-DD");
            let lastBilledDateTime_converted = currentDate_toString;
            let lastBilledDateTime_string = func_validation.getObjectPropertyValue(billingSetupDetails, "LastBilledDateTime");
            if (func_validation.isStringTrimNotEmpty(lastBilledDateTime_string)) {
                // Reformat Date Input
                let lastBilledDateTime_trimmed = func_validation.getTrimmedString(lastBilledDateTime_string);
                let dateDetail = lastBilledDateTime_trimmed.split("/");
                let date_reformatted = dateDetail[1] + "/" + dateDetail[0] + "/" + dateDetail[2];
                let lastBilledDateTime = new Date(date_reformatted);
                lastBilledDateTime.setUTCHours(lastBilledDateTime.getUTCHours() + 8);
                lastBilledDateTime_converted = lastBilledDateTime.toISOString();
            }

            let nextBilledDateTime_converted = currentDate_toString;
            let nextBilledDateTime_string = func_validation.getObjectPropertyValue(billingSetupDetails, "NextBilledDateTime");
            if (func_validation.isStringTrimNotEmpty(nextBilledDateTime_string)) {
                // Reformat Date Input
                let nextBilledDateTime_trimmed = func_validation.getTrimmedString(nextBilledDateTime_string);
                let dateDetail = nextBilledDateTime_trimmed.split("/");
                let date_reformatted = dateDetail[1] + "/" + dateDetail[0] + "/" + dateDetail[2];
                let nextBilledDateTime = new Date(date_reformatted);
                nextBilledDateTime.setUTCHours(nextBilledDateTime.getUTCHours() + 8);
                nextBilledDateTime_converted = nextBilledDateTime.toISOString();
            }

            let cutOffDate_converted = currentDate_toString;
            let cutOffDate_string = func_validation.getObjectPropertyValue(billingSetupDetails, "CutOffDate");
            if (func_validation.isStringTrimNotEmpty(cutOffDate_string)) {
                // Reformat Date Input
                let cutOffDate_trimmed = func_validation.getTrimmedString(cutOffDate_string);
                let dateDetail = cutOffDate_trimmed.split("/");
                let date_reformatted = dateDetail[0] + "/" + 1 + "/" + dateDetail[1];
                let cutOffDate = new Date(date_reformatted);
                cutOffDate.setUTCHours(cutOffDate.getUTCHours() + 8);
                cutOffDate_converted = cutOffDate.toISOString();
            }

            let lastBilledDateDay = func_validation.getObjectPropertyValue(billingSetupDetails, "LastBilledDateDay");

            let isSuspense = func_validation.getObjectPropertyValue(billingSetupDetails, "IsSuspense");
            let referenceKey = func_validation.getObjectPropertyValue(billingSetupDetails, "ReferenceKey", "") + "";
            let referenceKey_trimmed = func_validation.getTrimmedString(referenceKey);

            let referenceValue = func_validation.getObjectPropertyValue(billingSetupDetails, "ReferenceValue", "") + "";
            let referenceValue_trimmed = func_validation.getTrimmedString(referenceValue);

            let rowNo = func_validation.getObjectPropertyValue(billingSetupDetails, "rowNo", "");

            let billingSetup = {
                "Id": 0,
                "CompanyId": companyId,
                "AccountCode": accountCode_trimmed,
                "DealerCode": dealerCode_trimmed,
                "SalesPersonCode": salesPersonCode_trimmed,
                "ProductCode": productCode_trimmed,
                "ProductName": productName_trimmed,
                "IsDefaultProduct": isDefaultProduct? true:false,
                "ChargeMethod": chargeMethod_trimmed,
                "POSCountToCharge": posCountToCharge,
                "SystemChargeMethodComment": systemChargeMethodComment_trimmed,
                "SubscriptionMethod": subscriptionMethod_trimmed,
                "BillFrequence": billFrequence,
                "UnitPrice": unitPrice,
                "Quantity": quantity,
                "IsAdvancePay": advancePay,
                "UnitDiscountAmount": unitDiscountAmount,
                "IsBillInForeignCurrency": isBillInForeignCurrency? true:false,
                "CurrencyCode": currencyCode_trimmed,
                "CurrencyRate": currencyRate,
                "TransactionCountToCharge": transactionCountToCharge? transactionCountToCharge: 1,
                "LastBilledDateTime": lastBilledDateTime_converted,
                "LastBilledDateDay": lastBilledDateDay,
                "NextBilledDateTime": nextBilledDateTime_converted,
                "CutOffDate": cutOffDate_converted,
                "IsSuspense": isSuspense? true:false,
            }

            let billingSetupDetailsObj = {
                "Id": 0,
                "BillingSetupId": 0,
                "CompanyId": companyId,
                "ProductCode": productCode_trimmed,
                "ReferenceKey": referenceKey_trimmed,
                "ReferenceValue": referenceValue_trimmed
            };

            function generateMsg(completeMsg, errorMsg) {
                let completeMsg_new = completeMsg;
                if (completeMsg_new != "") completeMsg_new += "\n";
                completeMsg_new += "Row " + rowNo + ": " + errorMsg;
                return completeMsg_new;
            }

            /* Warnings */
            if (func_validation.isStringTrimEmpty(alertMsgType_new) ||
                func_validation.isStringEqual_caseInsensitive(alertMsgType_new, "warning")) {
                    
                if ((!companyId) ||
                    func_validation.isStringTrimEmpty(accountCode_trimmed) ||
                    func_validation.isStringTrimEmpty(productCode_trimmed)) {

                    alertMsg_new = generateMsg(alertMsg_new, "Will NOT be imported due to missing CompanyId, AccountCode, and/or ProductCode.");
                    alertMsgType_new = "warning";
                }
            }


            // Not included
            if (func_validation.isStringTrimEmpty(accountCode_trimmed) || 
                func_validation.isStringTrimEmpty(productCode_trimmed)) return "";

            /* Errors */
            // Company Id
            let msg = "";
            if (!func_validation.isNumberValid(companyId)) {
                msg = generateMsg(msg, "Company Id is not a valid number. (Ex: 1, 333, 4445, ...)")
            }
            // IsDefaultProduct
            if (!func_validation.isNullUndefined(isDefaultProduct) &&
                !(isDefaultProduct == 1 || isDefaultProduct == 0)) {

                msg = generateMsg(msg, "'Is Default Product' must be either 0 or 1.");
            }
            // Charge Method
            if (func_validation.isStringTrimNotEmpty(chargeMethod_trimmed) &&
                !(func_validation.isStringEqual_caseInsensitive(chargeMethod_trimmed, "License") ||
                func_validation.isStringEqual_caseInsensitive(chargeMethod_trimmed, "Outlet") ||
                func_validation.isStringEqual_caseInsensitive(chargeMethod_trimmed, "System") ||
                func_validation.isStringEqual_caseInsensitive(chargeMethod_trimmed, "OutletPos") ||
                func_validation.isStringEqual_caseInsensitive(chargeMethod_trimmed, "OutletTransaction"))) {

                msg = generateMsg(msg, "'Charge Method' spelling error (Options: License, Outlet, System, OutletPos, OutletTransaction).");
            }
            // POS Count To Charge
            if (func_validation.isNumberWithinRange(posCountToCharge, { max: -1 })) {
                msg = generateMsg(msg, "POS Count to Charge must be a positive number.");
            }
            // System Charge Method Comment
            if (func_validation.isStringTrimNotEmpty(systemChargeMethodComment_trimmed) &&
                (!func_validation.isStringEqual_caseInsensitive(chargeMethod_trimmed, "System"))) {
                
                msg = generateMsg(msg, "'Charge Method' must be of type System in order to input 'System Charge Method Comment'.");
            }
            // Subscription Method
            if (func_validation.isStringTrimNotEmpty(subscriptionMethod_trimmed) &&
                !(func_validation.isStringEqual_caseInsensitive(subscriptionMethod_trimmed, "Monthly") ||
                func_validation.isStringEqual_caseInsensitive(subscriptionMethod_trimmed, "Daily"))) {

                msg = generateMsg(msg, "Subscription method spelling error (Options: Monthly, Daily).");
            }
            // Bill Frequence
            if (!func_validation.isNumberValid(billFrequence) ||
                (billFrequence < 0)) {

                msg = generateMsg(msg, "'Bill Frequence' must be a positive number.");
            }
            // Unit Price
            if (!func_validation.isNumberValid(unitPrice)) {

                msg = generateMsg(msg, "'Unit Price' must be a number.");
            }
            // Unit Discount Amount
            if (!func_validation.isNumberValid(unitDiscountAmount) ||
                (unitDiscountAmount < 0)) {

                msg = generateMsg(msg, "'Unit Discount Amount' must be a positive number.");
            }
            // Advance Pay
            if (!func_validation.isNullUndefined(advancePay) &&
                !(advancePay == 1 || advancePay == 0)) {

                msg = generateMsg(msg, "'Advance Pay' must be either 0 or 1.");
            }
            // Quantity
            if (!func_validation.isNumberValid(quantity) ||
                (quantity < 0)) {

                msg = generateMsg(msg, "Quantity must be a positive number.");
            }
            // Transaction Count To Charge
            if (func_validation.isStringEqual_caseInsensitive(chargeMethod_trimmed, "OutletTransaction") &&
                func_validation.isNullUndefined(transactionCountToCharge)) {

                msg = generateMsg(msg, "'Transaction Count To Charge' is required.");
            }
            if (!func_validation.isNumberValid(transactionCountToCharge) ||
                (transactionCountToCharge < 0)) {

                msg = generateMsg(msg, "'Transaction Count To Charge' must be a positive number.");
            }
            // Is Bill In Foreign Currency
            if (!func_validation.isNullUndefined(isBillInForeignCurrency) &&
                !(isBillInForeignCurrency == 1 || isBillInForeignCurrency == 0)) {

                msg = generateMsg(msg, "'Is Bill In Foreign Currency' must be either 0 or 1.");
            }
            // Last Billed Date Day
            if ((!func_validation.isNumberValid(lastBilledDateDay)) ||
                (!((lastBilledDateDay > 0) && (lastBilledDateDay <= 31))) ) {

                msg = generateMsg(msg, "Last Billed Date Day must be between 1 and 31 inclusive.");
            }
            // Reference Key / Reference Value
            if (!isDefaultProduct && 
                (func_validation.isStringTrimEmpty(referenceKey_trimmed) && func_validation.isStringTrimEmpty(referenceValue_trimmed))) {

                msg = generateMsg(msg, "Must have either a reference key and/or an reference value.");
            }
            // Reference Value
            if (func_validation.getStringLength(referenceValue_trimmed) > 100) {

                msg = generateMsg(msg, "Reference Value exceeded 100 characters limit.");
            }
            // Is Suspense
            if (!func_validation.isNullUndefined(isSuspense) &&
                !(isSuspense == 1 || isSuspense == 0)) {

                msg = generateMsg(msg, "IsSuspense must be either 0 or 1.");
            }

            if (func_validation.isStringTrimNotEmpty(msg)) {
                // Reset
                if (func_validation.isStringEqual_caseInsensitive(alertMsgType_new, "warning")) {
                    alertMsg_new = "";
                }

                if (alertMsg_new != "") alertMsg_new += "\n";
                alertMsg_new += msg;
                alertMsgType_new = "error";
            }



            // Billing Setup Detail not required
            if (isDefaultProduct) {
                billingSetupList_new.push(func_validation.cloneObject(billingSetup));
            }
            else if (func_validation.isNumberWithinRange(companyId_current, { equal: companyId }) &&
                func_validation.isStringEqual_caseSensitive(accountCode_current, accountCode_trimmed) &&
                func_validation.isStringEqual_caseSensitive(productCode_current, productCode_trimmed) &&

                func_validation.isStringEqual_caseSensitive(dealerCode_current, dealerCode_trimmed) &&
                func_validation.isStringEqual_caseSensitive(salesPersonCode_current, salesPersonCode_trimmed) &&
                func_validation.isStringEqual_caseSensitive(productName_current, productName_trimmed) &&
                (isDefaultProduct_current === isDefaultProduct) &&
                func_validation.isStringEqual_caseSensitive(chargeMethod_current, chargeMethod_trimmed) &&
                func_validation.isNumberWithinRange(posCountToCharge_current, { equal: posCountToCharge }) &&
                func_validation.isStringEqual_caseSensitive(systemChargeMethodComment_current, systemChargeMethodComment_trimmed) &&
                func_validation.isStringEqual_caseSensitive(subscriptionMethod_current, subscriptionMethod_trimmed) &&
                func_validation.isNumberWithinRange(billFrequence_current, { equal: billFrequence }) &&
                func_validation.isNumberWithinRange(unitPrice_current, { equal: unitPrice }) &&
                func_validation.isNumberWithinRange(quantity_current, { equal: quantity }) &&
                func_validation.isNumberWithinRange(advancePay_current, { equal: advancePay }) &&
                func_validation.isNumberWithinRange(unitDiscountAmount_current, { equal: unitDiscountAmount }) &&
                (isBillInForeignCurrency_current === isBillInForeignCurrency) &&
                func_validation.isStringEqual_caseSensitive(currencyCode_current, currencyCode_trimmed) &&
                func_validation.isNumberWithinRange(currencyRate_current, { equal: currencyRate }) &&
                func_validation.isNumberWithinRange(transactionCountToCharge_current, { equal: transactionCountToCharge }) &&
                func_validation.isStringEqual_caseSensitive(lastBilledDateTime_current, lastBilledDateTime_converted) &&
                func_validation.isNumberWithinRange(lastBilledDateDay_current, { equal: lastBilledDateDay }) &&
                func_validation.isStringEqual_caseSensitive(nextBilledDateTime_current, nextBilledDateTime_converted) &&
                func_validation.isStringEqual_caseSensitive(cutOffDate_current, cutOffDate_converted) &&
                (isSuspense_current === isSuspense)){
                // Billing Setup Detail required

                let arraySize = billingSetupList_new.length;
                billingSetupList_new[arraySize - 1]["BillingSetupDetails"].push(billingSetupDetailsObj);                
            }
            else {
                billingSetupList_new.push(func_validation.cloneObject(billingSetup));
                let arraySize = billingSetupList_new.length;

                billingSetupList_new[arraySize - 1]["BillingSetupDetails"] = [];
                billingSetupList_new[arraySize - 1]["BillingSetupDetails"].push(billingSetupDetailsObj);

                // Initialize properties
                companyId_current = companyId;
                accountCode_current = accountCode_trimmed;
                productCode_current = productCode_trimmed;
                dealerCode_current = dealerCode_trimmed;
                salesPersonCode_current = salesPersonCode_trimmed;
                productName_current = productName_trimmed;
                isDefaultProduct_current = isDefaultProduct;
                chargeMethod_current = chargeMethod_trimmed;
                posCountToCharge_current = posCountToCharge;
                subscriptionMethod_current = subscriptionMethod_trimmed;
                billFrequence_current = billFrequence;
                unitPrice_current = unitPrice;
                quantity_current = quantity;
                advancePay_current = advancePay;
                unitDiscountAmount_current = unitDiscountAmount;
                isBillInForeignCurrency_current = isBillInForeignCurrency;
                currencyCode_current = currencyCode_trimmed;
                currencyRate_current = currencyRate;
                transactionCountToCharge_current = transactionCountToCharge;
                lastBilledDateTime_current = lastBilledDateTime_converted;
                lastBilledDateDay_current = lastBilledDateDay;
                nextBilledDateTime_current = nextBilledDateTime_converted;
                cutOffDate_current = cutOffDate_converted;
                isSuspense_current = isSuspense;
            }
        });

        setAlertMsg(alertMsg_new);
        setIsAlertMsgVisible(true);
        setAlertMsgType(alertMsgType_new);

        if (func_validation.isStringEqual_caseInsensitive(alertMsgType_new, "error")) {
            document.getElementById(inputUniqueId).value = "";
            return;
        }

        setBillingSetupList(billingSetupList_new);
    }
    function onChange_uploadedFile(e) {
        // Store File Name
        const { value: filePath } = e.target;
        if (func_validation.isStringTrimNotEmpty(filePath)) {
            // Get file name
            let fileName_startPos = filePath.lastIndexOf("\\") + 1;
            let fileName = filePath.substring(fileName_startPos);
            setUploadedFileName(fileName);
        }

        func_file.readUploadedFile_XLSX(e, 0, reformatBillingSetupListData);
    }
    function onClick_clearUploads() {
        document.getElementById(inputUniqueId).value = "";
        setUploadedFileName("");
        setBillingSetupList([]);
        setAlertMsg("");
        setIsAlertMsgVisible(false);
        setAlertMsgType("");
    }

    function importFiles() {
        if (func_validation.isFunction(props.importMassBillingSetup) &&
            func_validation.isArrayNotEmpty(billingSetupList) && 
            (func_validation.isStringTrimEmpty(alertMsg) ||
                func_validation.isStringEqual_caseInsensitive(alertMsgType, "warning"))) 
            props.importMassBillingSetup(billingSetupList);
    }

    function importFiles_errorMsg() {
        const { importMassBillingSetup_errorMsg, importMassBillingSetup_status } = props;

        if (func_validation.isBooleanFalseNotNullUndefined(importMassBillingSetup_requesting) &&
            func_validation.isStringTrimNotEmpty(importMassBillingSetup_errorMsg) &&
            func_validation.isBooleanFalseNotNullUndefined(importMassBillingSetup_status)) {

            setAlertMsg(importMassBillingSetup_errorMsg);
            setIsAlertMsgVisible(true);
            setAlertMsgType("error");
        }
        else {
            // Reset
            setAlertMsg("");
            setIsAlertMsgVisible(false);
            setAlertMsgType("");
        }
    }
    useEffect(() => {
        importFiles_errorMsg();
    }, [importMassBillingSetup_requesting]);

    return {
        uploadedFileName,
        isAlertMsgVisible,

        alertMsg,
        alertMsgType,
        setIsAlertMsgVisible,

        onChange_uploadedFile,
        onClick_clearUploads,
        importFiles,

        inputUniqueId
    }
}